export class LineLayers {
    static lineWithShadow(id, lineColor, lineWidth, shadowColor, shadowWidth) {
        let layers = [];

        layers.push({
            id: `${id}-shadow`,
            type: 'line',
            layout: {},
            paint: {
                'line-color': shadowColor,
                'line-width': shadowWidth,
            },
        });

        layers.push({
            id: `${id}-line`,
            type: 'line',
            layout: {},
            paint: {
                'line-color': lineColor,
                'line-width': lineWidth,
            },
        });

        return layers;
    }
}
